import React, { useState } from 'react';
import { Box, Grid, Modal, Switch } from '@mui/material';
import RoundButton from '../components/roundButton';

function LicenseModal(props) {
  const { open, handleClose, handleLicenseAccept } = props;
  const [isDisabled, setIsDisabled] = useState(true);

  const acceptLicense = event => {
    setIsDisabled(!event.target.checked);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className="custom-modal-bg overflow-auto"
      hideBackdrop
      disableEscapeKeyDown
    >
      <Box className="modal-common license-modal">
        <h3 className="modalTitle">
          LEGAL INFORMATION, NOTICES, &amp; LICENSE
        </h3>
        <hr />
        <h1
          style={{
            textAlign: 'center',
            padding: '4px',
            fontSize: '27px',
            fontWeight: '700'
          }}
        >
          END USER LICENSE AGREEMENT (EULA)
          <br />
          IMPORTANT: PLEASE READ CAREFULLY
        </h1>
        <p className="lh-1p5">
          Your use of the software, software as a service or other subscription,
          application or program (“Program”) and any user interfaces,
          descriptions, data, and/or any other information in any media or form
          whatsoever including user manuals or other documentation, drawings,
          specifications, certifications, tests and test results, catalogues and
          other promotional materials, data, images, sound recordings,
          multi-media and other presentations or materials (“Information”) which
          you may download or otherwise access from this site is subject to the
          following terms and conditions and to Parker’s &nbsp;
          <a
            href="https://www.parker.com/us/en/privacy-policies.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          , &nbsp; Terms of Use, &nbsp;
          <a
            href="https://www.parker.com/us/en/privacy-policies/cookie-policy.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy
          </a>
          , &nbsp;
          <a
            href="https://www.parker.com/portal/site/PARKER/menuitem.ab2358db22b75d08265ba8c5427ad1ca/?vgnextoid=2b4955b4d8876310VgnVCM10000014a71dacRCRD&amp;vgnextfmt=default"
            target="_blank"
            rel="noopener noreferrer"
          >
            Offer of Sale
          </a>
          , and &nbsp;
          <a
            href="https://www.parker.com/portal/site/PARKER/menuitem.c9e55a6ea039d4fdfd40eae8237ad1ca/?vgnextoid=f65d904cf58b2110VgnVCM100000c9040d0aRCRD&amp;vgnextfmt=default"
            target="_blank"
            rel="noopener noreferrer"
          >
            Safety Guide
          </a>
          &nbsp;(collectively “Terms and Conditions”) to the extent not
          inconsistent or in conflict with the terms of this EULA. If you do not
          wish to accept these Terms and Conditions, you are not permitted to
          use the Program or the Information.
        </p>
        <h3
          style={{
            textAlign: 'center',
            fontWeight: 'bold',
            textDecoration: 'underline'
          }}
        >
          Terms and Conditions
        </h3>
        <p className="lh-1p5">
          1. <span className="heading">WARNING</span>. YOU ARE STRONGLY ADVISED
          TO EXERCISE CAUTION IN YOUR USE OF THE PROGRAM AND INFORMATION AND ANY
          RESULTS OR OUTPUT GENERATED THEREBY. IMPROPER USE OF ANY OF THE SAME
          CAN CAUSE DEATH, PERSONAL INJURY, AND PROPERTY DAMAGE. YOU ARE SOLELY
          RESPONSIBLE FOR HOW THE PROGRAM AND INFORMATION, AND ANY RESULTS OR
          OUTPUT THEREOF, ARE USED AND FOR PREVENTING ANY DAMAGE TO ANY USER OF
          ANY MATERIAL, COMPONENT, OR SYSTEM SELECTED, SPECIFIED, OR DESIGNED
          THEREWITH OR TO ANY OF YOUR EMPLOYEES, AGENTS, CUSTOMERS, OR ANY OTHER
          PERSONS ARISING OUT OF ANY USE OR MISUSE OR ALTERATION OF THE PROGRAM
          OR INFORMATION, OR ANY RESULTS OR OUTPUT THEREOF WHETHER OR NOT
          INTENTIONAL, INCLUDING ANY ERROR, OMISSION, MISSTATEMENT OR DELETION
          IN OR OF THE PROGRAM OR INFORMATION, OR THE RESULTS OR OUTPUT THEREOF.
        </p>
        <p className="lh-1p5">
          The Program and Information may provide material, component and/or
          system options for further investigation by users having technical
          expertise, and is provided solely for use by users having such
          expertise. Before selecting or using any material, component or
          system, it is important that you analyze all aspects of your
          application. Due to the variety of operating conditions and
          applications which may be encountered, the user, through your own
          analysis and testing, is solely responsible for making the final
          selection and approval of any material, component or system and
          assuring that all performance, safety and warning requirements of the
          application are met. Final acceptance and approval of the material,
          component or system must be made by the user after testing its
          performance and endurance in the entire application under all
          conditions which might be encountered.
        </p>
        <p className="lh-1p5">
          The Program and Information may be updated, obsoleted, or otherwise
          changed by Parker at any time without notice, and you are solely
          responsible for maintaining Program and Information current in your
          permitted uses thereof.
        </p>
        <p className="lh-1p5">
          2. <span className="heading">Copyright</span>. The Program and
          Information are protected by copyright, and are owned exclusively by
          Parker-Hannifin Corporation, 6035 Parkland Boulevard, Cleveland, OH
          44124, and/or its parents, subsidiaries, affiliates and third party
          licensors (&quot;Parker&quot;). Nothing in these Terms and Conditions
          constitutes a waiver of Parker’s rights under United States or
          international copyright laws or any other international, federal or
          state law. Parker retains all rights not expressly granted under these
          Terms and Conditions.
        </p>
        <p className="lh-1p5">
          3. <span className="heading">Grant of License</span>. Parker hereby
          grants to you the end user, subject to these Terms and Conditions, a
          personal, non-exclusive, non-sublicensable, non-assignable,
          non-transferable, and limited license to use Program and Information
          for your own internal use and only for the purpose of conducting
          business with Parker. Any reproduction or redistribution of the
          Program not in accordance with these Terms and Conditions is expressly
          prohibited. WITHOUT LIMITING THE FOREGOING, COPYING OR REPRODUCTION OF
          THE PROGRAM or INFORMATION TO ANY OTHER SERVER OR LOCATION OR MEDIA
          FOR FURTHER REPRODUCTION OR REDISTRIBUTION IS EXPRESSLY PROHIBITED.
        </p>
        <p className="lh-1p5">
          4. <span className="heading">Ownership</span>. Except for any portions
          of the Program or Information owned or controlled by Parker’s third
          party licensors, Parker retains the ownership of the Program and
          Information, and any and all copies thereof. In no event shall you
          obtain any greater right in and to the Program and Information than a
          right in the nature of a license limited to the use thereof subject to
          compliance with all of these Terms and Conditions. As to any Open
          Source Software or other portions of the Program or Information owned
          or controlled by Parker’s third party licensors, such portions may be
          subject to terms separate from or in addition to these Terms and
          Conditions. Any such terms are transferred rather than sublicensed to
          you. A copy any such terms may be appended to these terms and
          Conditions.
        </p>
        <p className="lh-1p5">
          5.<span className="heading">Prohibited Uses</span>. You may not,
          without the prior, written permission of Parker:
        </p>
        <p className="lh-1p5">
          (a) Use, copy, modify, or merge copies of all or any part of the
          Program and Information;
        </p>
        <p className="lh-1p5">
          (b) Reverse engineer, disassemble, reverse translate, decrypt, or in
          any manner decode any part of the Program and Information;
        </p>
        <p className="lh-1p5">
          (c) Distribute, sell, license, assign, rent, sublicense, lease or
          otherwise transfer in any way all or any part of the Program and
          Information; or
        </p>
        <p className="lh-1p5">
          (d) Remove any proprietary notices, labels, or other markings on, in,
          or from the Program and Information.
        </p>
        <p className="lh-1p5">
          6. <span className="heading">Term</span>. This license and your right
          to use the Program and Information shall automatically terminate if
          you fail to comply with any of these Terms and Conditions. Parker may
          at any time, without prior cause or notice, and in its sole
          discretion: (a) modify, update, obsolete, revise, alter, change,
          withdraw, or cancel the Program and Information or any module or other
          functionality thereof; (b) terminate the license herein grant and/or
          your use of or access to the Program and Information or any module or
          functionality thereof; and/or (c) modify these Terms and Conditions
          and/or the terms and conditions of your use of or access to the
          Program and Information or any module or functionality thereof. The
          Program and Information shall be removed from your systems and
          devices, and any access thereof shall be immediately terminated upon
          termination of this Agreement regardless of which party is the
          terminating party.
        </p>
        <p className="lh-1p5">
          7. <span className="heading">WARRANTY DISCLAIMER</span>. THE PROGRAM
          AND INFORMATION, AND ANY RESULTS OR OUTPUT THEREOF, ARE PROVIDED
          &quot;AS IS&quot; AND WITHOUT WARRANTY OR CONDITION OF ANY KIND,
          EITHER EXPRESS OR IMPLIED INCLUDING, BUT NOT LIMITED TO
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR
          NON-INFRINGEMENT. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING,
          PARKER DOES NOT WARRANT THAT THE PROGRAM AND INFORMATION WILL MEET
          YOUR REQUIREMENTS, THAT THE OPERATION OF PROGRAM WILL BE UNINTERRUPTED
          OR ERROR FREE, OR THAT ANY INACCURACIES OR ERRORS IN, OR FAILURES OF,
          THE PROGRAM AND INFORMATION WILL BE CORRECTED, AND PARKER SHALL HAVE
          NO OBLIGATION TO CORRECT ANY SUCH INACCURACIES, ERRORS, OR FAILURES OR
          TO UPDATE OR OTHERWISE MAINTAIN THE PROGRAM AND INFORMATION.
        </p>
        <p className="lh-1p5">
          8. <span className="heading">LIMITATION OF LIABILITY</span>. IN NO
          EVENT SHALL PARKER, ITS AGENTS, SUPPLIERS, OR DISTRIBUTORS BE LIABLE
          TO YOU OR ANY THIRD PARTY FOR ANY DAMAGES OF ANY KIND WHATSOEVER,
          INCLUDING ANY LOST PROFITS, LOST SAVINGS, OR ANY SPECIAL, INCIDENTAL,
          INDIRECT, OR CONSEQUENTIAL DAMAGES, ARISING OUT OF EITHER THE USE OR
          INABILITY TO USE THE PROGRAM OR INFORMATION, OR ANY RESULTS OR OUTPUT
          THEREOF, EVEN IF PARKER HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH
          DAMAGES. RATHER, YOU THE USER HEREBY AGREE TO DEFEND, INDEMNIFY AND
          HOLD HARMLESS PARKER, ITS PARENTS, AFFILIATES, LICENSEES, SUPPLIERS,
          AND DISTRIBUTORS, AND THEIR RESPECTIVE DIRECTORS, OFFICERS, EMPLOYEES
          AND AGENTS, FROM AND AGAINST ALL LIABILITIES, CLAIMS, INCLUDING FOR
          INFRINGEMENT OF ANY PATENT, TRADEMARK, TRADE SECRET, COPYRIGHT, OR
          OTHER INTELLECTUAL PROPERTY OR PROPRIETARY RIGHT, DAMAGES, JUDGMENTS,
          LOSSES, AWARDS, AND EXPENSES, INCLUDING ATTORNEY’S FEES, ARISING OUT
          OF YOUR USE, OR INABILITY TO USE, THE PROGRAM OR INFORMATION, AND ANY
          RESULTS OR OUTPUT THEREOF, OR FOR YOUR VIOLATION OR ALLEGED VIOLATION
          OF THESE TERMS AND CONDITIONS, OR FOR YOUR VIOLATION OR ALLEGED
          VIOLATION OF THESE TERMS AND CONDITIONS, OR YOUR BREACH OF ANY
          WARRANTY OR OTHER PROVISION OF THESE TERMS AND CONDITIONS, OR YOUR
          VIOLATION OF ANY APPLICABLE LAW OR REGULATION, OR ANY DAMAGE OR OTHER
          HARM CAUSED AS A RESULT OF YOUR WILLFUL, RECKLESS OR NEGLIGENT ACT OR
          OMISSION.
        </p>
        <p className="lh-1p5">
          9. <span className="heading">Data; Feedback</span>. You grant to
          Parker a royalty-free, perpetual, non-exclusive, unrestricted,
          worldwide license to: (i) use, reproduce, backup, store, transfer,
          maintain, copy, sublicense, adapt, transmit, retransmit, distribute
          and/or publicly perform or display any and all data and feedback
          provided or generated by You in connection with the Program, or
          collected, processed, compiled, or generated by the Program for
          improving and enhancing the Software and for any other commercial,
          noncommercial or other lawful purpose; and (ii) sublicense to third
          parties the unrestricted right to exercise any of the foregoing rights
          granted with respect to any such feedback and data. Parker accepts no
          obligation for maintaining the confidentiality of any such feedback or
          data. You warrant that You have the right to license use of such data
          and feedback to Parker, that such data and feedback do not infringe or
          otherwise violate any patent, trade secret, copyright, right of
          publicity or privacy, moral right, or other intellectual or
          proprietary right of any third party, and that such data and feedback
          are not subject to any license terms that would require Parker to
          comply with any additional obligations with respect to any product or
          service that incorporates such data or feedback.
        </p>
        <p className="lh-1p5">
          10. <span className="heading">Assignment</span>. You may not
          sublicense, assign, or transfer the license herein granted or the
          Program or Information. Any attempt otherwise to sublicense, assign,
          or transfer any of the same or rights hereunder shall be null and
          void.
        </p>
        <p className="lh-1p5">
          11. <span className="heading">Governing Law</span>. This Agreement
          shall be governed by the laws of the State of Ohio, USA without regard
          to its conflict of laws rules or principles.
        </p>
        <p className="lh-1p5">
          12. <span className="heading">Acceptance</span>. Your use of the
          Program and Information is conditional upon your acceptance of these
          Terms and Conditions. If you do not wish to accept these Terms and
          Conditions, you are not permitted to use the Program or Information.
          In such event, please return the Program and Information to Parker at
          the address set forth above.
        </p>
        <p className="lh-1p5">
          Copyright © Parker-Hannifin Corporation. The year of copyright is the
          current year. All rights reserved. Other copyrights as indicated in
          the Information or as of the date of the Information.
        </p>
        <b>Last updated: March 2018</b>
        <h3 style={{ fontSize: '15px' }}>“Opt in” terms:</h3>
        <div className="well">
          <Switch onClick={acceptLicense} />

          <span>
            I consent that my data may be transmitted to servers outside the
            country where the information was entered, and may be used, stored
            and processed outside of the country where it was entered. For
            additional information click&nbsp;
            <a href="http://www.parker.com/portal/site/PARKER/menuitem.4450f18f18c082cdfd40eae8237ad1ca/?vgnextoid=760b904cf58b2110VgnVCM100000c9040d0aRCRD&amp;vgnextfmt=default">
              here.
            </a>
          </span>
        </div>
        <hr />
        <Grid container>
          <Grid item xs={0} sm={8} md={8} lg={8} />
          <Grid item xs={12} sm={2} md={2} lg={2} className="pr-1">
            <RoundButton
              name="REJECT"
              onClick={() => {
                handleClose();
                window.location = 'http://www.parker.com';
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2} md={2} lg={2}>
            <RoundButton
              name="ACCEPT"
              disabled={isDisabled}
              classname="yellow-button"
              onClick={() => {
                handleLicenseAccept();
                handleClose();
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default LicenseModal;
